<ul class="list">
  <li class="list-item" *ngFor="let item of data; let i = index">
    <input #listInput class="checkbox" id="input-{{id}}-{{i}}" [name]="id" type="radio">
    <label
      (click)="change(item.value)"
      class="list-item-label"
      for="input-{{id}}-{{i}}"
      [innerHTML]="item.label"></label>
  </li>
</ul>
